"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Table, VisuallyHidden } from "@mantine/core";
import { capitalize } from "../../../utilities/index.js";
const TableTdWrapper = ({ children, header, hideCardLabels }) => /* @__PURE__ */ jsx(Table.Td, { "data-label": !hideCardLabels ? capitalize(header) : void 0, children: /* @__PURE__ */ jsxs("div", { className: "td-content", children: [
  hideCardLabels && /* @__PURE__ */ jsx(VisuallyHidden, { children: header }),
  children
] }) });
export {
  TableTdWrapper as default
};
